/* Sticky header + filter bar positioning.
   1) Announcement bar + header: apply position:sticky via JS
   2) Filter bar: toggle position:fixed when scrolled past its natural position
   Uses JS instead of CSS sticky to avoid Safari overflow-x:hidden bug. */
(function(){
  var headerHeight = 0;

  function setupHeader() {
    var ab = document.querySelector('.shopify-section-group-header-group.mount-announcement-bar');
    var hd = document.querySelector('.shopify-section-group-header-group.mount-header');
    if (!ab || !hd) return;

    ab.style.position = 'sticky';
    ab.style.top = '0';
    ab.style.zIndex = '8889';

    var abHeight = ab.offsetHeight;
    hd.style.top = abHeight + 'px';
    hd.style.zIndex = '8888';

    headerHeight = abHeight + hd.offsetHeight;
    document.documentElement.style.setProperty('--sticky-header-height', headerHeight + 'px');
  }

  function setupFilterBar() {
    var fb = document.querySelector('.type-filter-bar');
    if (!fb) return;

    // Create placeholder to prevent content jump when filter goes fixed
    var placeholder = fb.nextElementSibling;
    if (!placeholder || !placeholder.classList.contains('filter-bar-placeholder')) {
      placeholder = document.createElement('div');
      placeholder.className = 'filter-bar-placeholder';
      placeholder.style.display = 'none';
      fb.parentNode.insertBefore(placeholder, fb.nextSibling);
    }

    var naturalTop = 0;
    var isFixed = false;
    var fbHeight = fb.offsetHeight;

    function measure() {
      // Measure natural position when NOT fixed
      if (isFixed) {
        fb.classList.remove('is-fixed');
        placeholder.style.display = 'none';
        isFixed = false;
      }
      fbHeight = fb.offsetHeight;
      var rect = fb.getBoundingClientRect();
      naturalTop = rect.top + window.scrollY;
    }

    function onScroll() {
      var scrollY = window.scrollY;
      var triggerPoint = naturalTop - headerHeight;

      if (scrollY > triggerPoint) {
        if (!isFixed) {
          fbHeight = fb.offsetHeight;
          placeholder.style.display = 'block';
          placeholder.style.height = fbHeight + 'px';
          fb.classList.add('is-fixed');
          isFixed = true;
        }
      } else {
        if (isFixed) {
          fb.classList.remove('is-fixed');
          placeholder.style.display = 'none';
          isFixed = false;
        }
      }
    }

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function() {
      measure();
      onScroll();
    });
  }

  function init() {
    setupHeader();
    setupFilterBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', setupHeader);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function() {
      setupHeader();
      setupFilterBar();
    });
  }
})();
